var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99984 3.83305C5.90779 3.83305 5.83317 3.90767 5.83317 3.99972V15.9997C5.83317 16.0918 5.90779 16.1664 5.99984 16.1664H13.9998C14.0919 16.1664 14.1665 16.0918 14.1665 15.9997V6.41393C14.1665 6.36973 14.1489 6.32733 14.1177 6.29608L11.7035 3.88186C11.6722 3.85061 11.6298 3.83305 11.5856 3.83305H5.99984ZM4.1665 3.99972C4.1665 2.98719 4.98731 2.16638 5.99984 2.16638H11.5856C12.0719 2.16638 12.5382 2.35954 12.882 2.70335L15.2962 5.11757C15.64 5.46138 15.8332 5.9277 15.8332 6.41393V15.9997C15.8332 17.0122 15.0124 17.833 13.9998 17.833H5.99984C4.98731 17.833 4.1665 17.0122 4.1665 15.9997V3.99972Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8331 10.9997C12.8331 11.4599 12.46 11.833 11.9998 11.833H7.99976C7.53952 11.833 7.16642 11.4599 7.16642 10.9997C7.16642 10.5395 7.53952 10.1664 7.99976 10.1664H11.9998C12.46 10.1664 12.8331 10.5395 12.8331 10.9997Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrder);
export default __webpack_public_path__ + "static/media/purchaseOrder.a9cc87145fa3c48d78fd632f336f3d6d.svg";
export { ForwardRef as ReactComponent };